/*
 * FORM TEAMBUILDING TOUR
 *
 * Flat fee per group, driven by the tour duration shared by the whole booking.
 * Prices come from the durationRepeat CMS repeater and are carried by each radio
 * as data-price-first / data-price-add, so editors can change them without a deploy.
 */

import { parsePrice, formatPrice } from "./price-utils.js";

const MIN_PEOPLE_PER_GROUP = 4;
const MAX_PEOPLE_PER_GROUP = 10;
const MAX_GROUPS = 5;
const INVALID_COLOR = "var(--color-red-lcto)";

document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("formTeambuilding");
  if (!form) return;

  const groups = Array.from(form.querySelectorAll(".js-tour-group"));
  const addButton = form.querySelector(".js-add-tour-group");
  const removeButton = form.querySelector(".js-remove-tour-group");
  const maxMessage = form.querySelector(".js-tour-group-max");
  const totalInput = form.querySelector(".js-total-tour");
  const groupCountInput = form.querySelector(".js-nb-groups");

  if (groups.length === 0) return;

  const visibleGroups = () => groups.filter((group) => !group.classList.contains("hidden"));

  const updateTotal = () => {
    const checked = form.querySelector('[name="durationtour"]:checked');
    const count = visibleGroups().length;

    if (groupCountInput) groupCountInput.value = count;
    if (!totalInput) return;

    if (!checked) {
      totalInput.value = "0";
      return;
    }

    const first = parsePrice(checked.dataset.priceFirst);
    const additional = parsePrice(checked.dataset.priceAdd);
    totalInput.value = formatPrice(first + (count - 1) * additional);
  };

  const refreshControls = () => {
    const count = visibleGroups().length;
    if (addButton) addButton.classList.toggle("hidden", count >= MAX_GROUPS);
    if (removeButton) removeButton.classList.toggle("hidden", count <= 1);
    if (maxMessage) maxMessage.classList.toggle("hidden", count < MAX_GROUPS);
  };

  const clearGroup = (group) => {
    group.querySelectorAll("input, select").forEach((field) => {
      field.value = "";
      field.style.removeProperty("border-color");
      field.style.removeProperty("box-shadow");
    });
    const error = group.querySelector(".js-tour-people-error");
    if (error) error.classList.add("hidden");
  };

  const validatePeople = (input) => {
    const group = input.closest(".js-tour-group");
    const error = group ? group.querySelector(".js-tour-people-error") : null;
    const value = parseInt(input.value, 10);
    // An empty field is left to the generic required-field validation
    const invalid = input.value.trim() !== "" && (isNaN(value) || value < MIN_PEOPLE_PER_GROUP || value > MAX_PEOPLE_PER_GROUP);

    if (error) error.classList.toggle("hidden", !invalid);
    if (invalid) {
      input.style.setProperty("border-color", INVALID_COLOR, "important");
      if (input.type === "radio") {
        input.style.setProperty("box-shadow", "0px 0px 4px red", "important");
      }
    } else {
      input.style.removeProperty("border-color");
      input.style.removeProperty("box-shadow");
    }
    return !invalid;
  };

  if (addButton) {
    addButton.addEventListener("click", () => {
      const next = groups.find((group) => group.classList.contains("hidden"));
      if (next) {
        next.classList.remove("hidden");
        const firstField = next.querySelector("input, select");
        if (firstField) firstField.focus();
      }
      refreshControls();
      updateTotal();
    });
  }

  if (removeButton) {
    removeButton.addEventListener("click", () => {
      const visible = visibleGroups();
      if (visible.length <= 1) return;
      const last = visible[visible.length - 1];
      last.classList.add("hidden");
      clearGroup(last);
      refreshControls();
      updateTotal();
    });
  }

  form.querySelectorAll('[name="durationtour"]').forEach((radio) => {
    radio.addEventListener("click", updateTotal);
    radio.addEventListener("change", updateTotal);
  });

  form.querySelectorAll(".js-tour-people").forEach((input) => {
    input.addEventListener("input", () => validatePeople(input));
    input.addEventListener("change", () => validatePeople(input));
  });

  form.addEventListener("submit", function (e) {
    let firstInvalid = null;
    for (const group of visibleGroups()) {
      const input = group.querySelector(".js-tour-people");
      if (input && !validatePeople(input) && !firstInvalid) {
        firstInvalid = input;
      }
    }

    if (firstInvalid) {
      e.preventDefault();
      e.stopPropagation();
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });

  refreshControls();
  updateTotal();
});
